{
  "admins": {
    "errors": {
      "add": "Không thể thêm quản trị viên.",
      "notFound": "Không thể tìm thấy quản trị viên đó."
    }
  },
  "home": {
    "goToSandbox": "Đi đến sandbox",
    "subtitle": "Repo này là điểm khởi đầu để xây dựng ứng dụng web với React, shadcn-ui và TanStack Router.",
    "title": "Chào mừng đến với Mẫu React Mindsea."
  },
  "login": {
    "errors": {
      "invalidEmail": "Vui lòng nhập địa chỉ email hợp lệ.",
      "unauthorized": "Bạn không có quyền truy cập ứng dụng này."
    },
    "placeholder": "name@example.com",
    "sendCode": "Gửi mã",
    "subtitle": "Xây dựng trang đăng nhập tại đây.",
    "title": "Đăng nhập"
  }
}
